import { render, staticRenderFns } from "./pains-analysis-item.vue?vue&type=template&id=334048b0&scoped=true"
import script from "./pains-analysis-item.vue?vue&type=script&lang=js"
export * from "./pains-analysis-item.vue?vue&type=script&lang=js"
import style0 from "./pains-analysis-item.vue?vue&type=style&index=0&id=334048b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334048b0",
  null
  
)

export default component.exports